export enum PatientDetailsCardId {
  LAB_TESTS = 'lab-tests',
  LAB_ORDER = 'lab-order',
  DOCUMENTS = 'documents',
  PRESCRIPTIONS = 'prescriptions',
  PREGNANCY = 'pregnancy',
  ANESTHESIA = 'anesthesia',
  EXAMINATION = 'examination',
  BLOOD = 'blood',
  CONSENT = 'consent',
  IDENTITY = 'identity',
  ORIGINAL_SURGERY = 'original-surgery',
  SURGERY = 'surgery',
  POSTOP_AND_CHART = 'postop-chart',
  MONITORING = 'monitoring',
  COMMUNICATION = 'communication',
  BILLING = 'billing',
  EPIC_DOCUMENTS = 'epic-documents',
  PRESCRIPTION_BUILDER = 'presc-builder',
  MEDS = 'meds',
  MEDICAL_HO = 'medical-ho',
  POSTOP_PAIN = 'postop-pain',
  PREMEDICATION = 'premedication'
}
